import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { VideoPlaybackModalContent } from './VideoPlaybackModalContent';
import { VideoPlaybackModalDesktop } from './VideoPlaybackModalDesktop';
import { VideoPlaybackModalHeader } from './VideoPlaybackModalHeader';

interface IVideoPlaybackModalProps extends IWithDeviceTypeProps {
  isOpen: boolean;
  onClose(): void;
  videoSrc: string;
}

/**
 * Компонент модального окна с проигрывателем видео на весь его размер.
 */
const VideoPlaybackModal: React.FC<React.PropsWithChildren<IVideoPlaybackModalProps>> = ({
  isOpen,
  isDesktop,
  onClose,
  videoSrc,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      {isDesktop ? (
        <VideoPlaybackModalDesktop onClose={onClose} isOpen={isOpen}>
          <VideoPlaybackModalContent videoSrc={videoSrc} />
        </VideoPlaybackModalDesktop>
      ) : (
        <ModalFullscreen open={isOpen} onClose={onClose}>
          <VideoPlaybackModalHeader onClose={onClose} />
          <VideoPlaybackModalContent videoSrc={videoSrc} />
        </ModalFullscreen>
      )}
    </>
  );
};

const VideoPlaybackModalWithDeviceType = withDeviceType(VideoPlaybackModal);
export { VideoPlaybackModalWithDeviceType as VideoPlaybackModal };
